// extracted by mini-css-extract-plugin
module.exports = {"debugger":"debugger--1OqCy"};